module.exports = __webpack_public_path__ + "img/chet_school.7108dec3.svg";